import { ReactNode } from 'react';
import { useAbility } from '../../users/AbilityContext';
import { ChatContextProvider } from './chat/chat.context';
import { ChatModalContextProvider } from './chatModal/ChatModal.context';
import { ChatSocketContextProvider } from './chatSocket/chatSocket.context';

interface ChatProvidersBundleProps {
  children: ReactNode;
}

const ChatProvidersBundle = ({ children }: ChatProvidersBundleProps) => {
  const ability = useAbility();

  if (ability.isLoadingAbilities || ability.cannot('read', 'chats')) {
    return children;
  }

  return (
    <ChatModalContextProvider>
      <ChatSocketContextProvider>
        <ChatContextProvider>{children}</ChatContextProvider>
      </ChatSocketContextProvider>
    </ChatModalContextProvider>
  );
};

export default ChatProvidersBundle;
